module.exports = __webpack_public_path__ + "static/media/1_10.957af4a8.jpg";